<template>
	<div class="m_container">
		<div class="bgfff vh100 w100">
			<div class="top page_bg" id="top" :style="'height:' + H + 'px;'">
				<!-- <div class="top-content bgfff pt20 plr20">
					<div class="mb20 txt_center">项目积分情况</div>
					<div class="flex flex_between flex_items ">
						<div class="">
							<div class="txt_center mb10">30</div>
							<div class="ca6">总积分</div>
						</div>
						<div class="">
							<div class="txt_center mb10">30</div>
							<div class="ca6">已发放</div>
						</div>
						<div class="">
							<div class="txt_center mb10">30</div>
							<div class="ca6">剩余积分</div>
						</div>
					</div>
				</div> -->
				<div class=" plr20 flex_items bgfff">
					<div class="bor_b flex flex_items flex_between" @click="show1 = true"
						style="height: 60px;box-sizing: border-box;">
						<div class="flex1 flex flex_items">
							<div class="" style="width: 100px;">会员姓名</div>
							<div :class="name.name1 ? '' : 'ca6'">{{name.name1 ? name.name1 : '请选择会员姓名'}}</div>
						</div>
						<van-icon name="arrow" />
					</div>
					<div class="bor_b flex flex_items flex_between" style="height: 60px;box-sizing: border-box;">
						<div class="" @click="show2 = true">
							<div :class="timer ? '' : 'ca6'">{{timer ? timer : '选择开始日期'}}
								<van-icon name="arrow-down" />
							</div>
						</div>
						<div class="" @click="show3 = true">
							<div :class="timerEnd ? '' : 'ca6'">{{timerEnd ? timerEnd : '选择结束日期'}}
								<van-icon name="arrow-down" />
							</div>
						</div>
					</div>
					<!-- <div class="flex flex_items ca6" style="height: 50px;">
						（注：三选一即可）
					</div> -->
				</div>
			</div>
			<div class="content" :style="'padding-top:'+H +'px;'">
				<div class="bgfff" v-for="(item, index) in sList" :key="index">
					<div class="bor_b plr20 pt20 pb20 flex_between flex_items" v-if="t == 1">
						<div class="">
							<div class="mb10">{{item.user ? item.user.name : ''}}{{item.user ? item.user.phone : ''}}</div>
							<div class="ca6">{{item.updated_at}}</div>
						</div>
						<div :class="item.amount > 0 ? 'main_color' : 'red'">{{item.amount}}</div>
					</div>
					<div class="bor_b plr20 pt20 pb20" v-else>
						<div class="flex_between flex_items mb10">
							<div class="">{{item.name ? item.name : ''}}</div>
							<div class="">总积分:{{item.score ? item.score.total : ''}}</div>
						</div>
						<div class="flex_between flex_items">
							<div class="">已冲销:{{item.score ? item.score.exchange : ''}}</div>
							<div class="">剩余积分:{{item.score ? item.score.remain : ''}}</div>
						</div>
					</div>
				</div>
				<div class="empty" v-if="sList.length == 0">
					暂无数据
				</div>
			</div>
			<!-- 选择名字 -->
			<Popup v-model="show1" position="bottom">
				<Picker :show-toolbar="true" title=" " value-key="name1" :columns="list" @confirm="nameOnConfirm"
					@cancel="show1 = false" />
			</Popup>
			<!-- 选择时间 -->
			<Popup v-model="show2" position="bottom">
				<DatetimePicker v-model="timerS" @cancel="show2 = false" @confirm="confirm" type="date" title="选择开始日期">
				</DatetimePicker>
			</Popup>
			<Popup v-model="show3" position="bottom">
				<DatetimePicker v-model="timerSE" @cancel="show3 = false" @confirm="confirm1" type="date"
					title="选择结束日期">
				</DatetimePicker>
			</Popup>
		</div>
	</div>
</template>

<script>
	import {
		List,
		Popup,
		DatetimePicker,
		Picker
	} from "vant";
	export default ({
		components: {
			List,
			Popup,
			DatetimePicker,
			Picker
		},
		data() {
			return {
				pcPt: 120,
				handleClick: 0,
				list: [],
				show1: false,
				show2: false,
				show3: false,
				loading: false,
				finished: false,
				name: {}, //会员名
				intergal: '', //积分
				// H: 320,
				H: 130,
				timer: '',
				timerEnd: '',
				timerS: new Date(),
				timerSE: new Date(),
				username: '',
				title: '',
				flag: true,
				sList: [],
				selectObj: {},
				id:'',
				t:0,//1-积分 2-积分汇总
			}
		},
		methods: {
			nameOnConfirm(e) {
				this.name = e;
				this.username = e.id;
				this.selectObj.user_id = e.id;
				this.getList()
				this.show1 = false
			},
			confirm(e) {
				let m = (e.getMonth() + 1).toString().length == 1 ? '0' + (e.getMonth() + 1) : (e.getMonth() + 1)
				this.selectObj.date_start = e.getFullYear() + '-' + m + '-' + e.getDate();
				this.timer = e.getFullYear() + '年' + (e.getMonth() + 1) + '月' + e.getDate() + '日';
				this.show2 = false;
				this.getList()
			},
			confirm1(e) {
				let m = (e.getMonth() + 1).toString().length == 1 ? '0' + (e.getMonth() + 1) : (e.getMonth() + 1)
				this.selectObj.date_end = e.getFullYear() + '-' + m + '-' + e.getDate();
				this.timerEnd = e.getFullYear() + '年' + (e.getMonth() + 1) + '月' + e.getDate() + '日';
				this.show3 = false;
				this.getList()
			},
			getUserData() {
				this.api.projectUser({},this.id).then(res => {
					let arr = []
					res.data.map(r => {
						if(r.role == 'member'){
							r.name1 = r.name + r.phone;
							arr.push(r)
						}
					})
					this.list = [{id:0,name:'全部',name1:'全部'}].concat(arr);
				})
			},
			getList() {
				// console.log(this.selectObj)
				if(this.t == 1){
					this.api.scoreLogs(this.selectObj).then(res => {
						this.sList = res.data;
					})
				}else{
					this.selectObj.project_id = this.id
					this.api.scoreInfo(this.selectObj).then(res => {
						this.sList = res.data;
					})
				}
			},
		},
		created() {
			this.id = this.$route.query.id;
			this.t = this.$route.query.t;
			this.selectObj.project_id = this.id;
			if(this.t == 1){
				document.title = "积分明细";
			}else if(this.t == 2){
				document.title = "积分汇总";
			}
			this.getUserData();
			this.getList();
		}
	})
</script>

<style scoped="scoped">
	.top-s>div {
		width: 85px;
		height: 40px;
		line-height: 40px;
		border-radius: 10px;
	}

	.top {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}

	.top,
	.pc-top {
		width: 390px;
		left: 50%;
		transform: translateX(-50%);
	}

	.top-content {
		height: 130px;
		box-sizing: border-box;
	}

	.content {
		box-sizing: border-box;
		overflow-y: auto;
		height: 100%;
		padding-bottom: 130px;
	}

	textarea {
		border: 0;
		resize: none
	}
</style>
